import React from 'react';
import { journey } from '../data/materials';
export function JourneySection() {
  return <section className="py-10 px-4 bg-gray-50" data-id="element-80" data-mp="blo8f1mbx9b6">
      <div className="max-w-3xl mx-auto text-center" data-id="element-81" data-mp="bnirsbhyctd5">
        <h2 className="text-[20px] md:text-2xl font-black text-[#14356B] mb-2" data-id="element-82" data-mp="3t2xxrjrtueuc">
          3 MATERIALES. UN MISMO CAMINO.
        </h2>
        <p className="text-gray-600 mb-6" data-id="element-83" data-mp="1wwkd4ke395j">
          120 páginas listas para acompañar distintas etapas de Catequesis.
        </p>

        <div className="space-y-2" data-id="element-84" data-mp="pjwafny830t7">
          {journey.map((step, index) => <React.Fragment key={step.title} data-id="element-85" data-mp="ujh6nqm0cv28" data-mpi={index}>
              {index > 0 && <p className="text-[#157C8B] text-lg" aria-hidden="true" data-id="element-86" data-mp="glkauwfdosom">
                  ⬇️
                </p>}
              <div className="bg-white border border-gray-200 rounded-2xl p-4" data-id="element-87" data-mp="kluqz1wvwzh7">
                <h3 className="text-lg font-black text-[#14356B]" data-id="element-88" data-mp="31bi10wwk3bqe">
                  {step.title}
                </h3>
                <p className="text-base text-gray-700" data-id="element-89" data-mp="35d3kx27icqa3">{step.description}</p>
              </div>
            </React.Fragment>)}
        </div>

        <p className="mt-6 text-base font-bold text-[#157C8B]" data-id="element-90" data-mp="2zfturdcteqr2">
          Un recorrido que podés utilizar durante muchísimo más que una sola
          clase.
        </p>
      </div>
    </section>;
}